import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

import BoxWrapper from "../../box-wrapper";
import useGatAdminConfigData from "../../controllers/use-gat-admin-config-data";
import { setWorkCenterDialog } from "../../store/gat-admin-slice";
import { getLocations, resetCreateNewWorkCenter, resetUpdateWorkCenterData } from "../../store/gat-admin-slice";
import WorkCenterDialog from "./work-center-dialog/work-center-dialog";
import WorkCenterTable from "./work-center-table";

interface WorkCentersProps {
	location: any;
}

const WorkCenters = ({
	location,
}: WorkCentersProps) => {
	const defaultWorkCenterInfo = React.useMemo(() => ({
		id: 0,
		name: "",
		code: "",
		locationId: location && location.length ? location[0].id : 0,
		companyId: location && location.length ? location[0].companyId : 0,
		shiftPatternIds: [],
	}), [location]);
	const [workCenterData, setWorkCenterData] = useState({});
	const dispatch = useDispatch();
	const { shiftPatterns, createNewWorkCenterStatus, createNewWorkCenterErrorMessage, updateWorkCenterStatus, updateWorkCenterErrorMessage } = useGatAdminConfigData();
	const [creatingNewWorkCenter, setCreatingNewWorkCenter] = useState(false);

	if (!location || !location.length) return null;
	const locationObject = location[0];
	return (
		<>
			<BoxWrapper
				title='Workcenters'
				subtitle={`All workcenters for ${locationObject.name}`}
				openDialog={() => {
					dispatch(setWorkCenterDialog(true));
					setCreatingNewWorkCenter(true);
					setWorkCenterData(defaultWorkCenterInfo);
				}}
			>
				<WorkCenterTable
					currentLocationData={locationObject}
					// workCenters ={currentLocationData.workCenters}
					setWorkCenterData={setWorkCenterData}
					openDialog={() => {
						dispatch(setWorkCenterDialog(true));
					}}
				/>
			</BoxWrapper>

			<WorkCenterDialog
				creatingNewWorkCenter={creatingNewWorkCenter}
				workCenterData={workCenterData}
				setWorkCenterData={(newValue: any) => setWorkCenterData(newValue)}
				onClose={() => {
					dispatch(setWorkCenterDialog(false));
					setCreatingNewWorkCenter(false);
				}}
				shiftPatterns={shiftPatterns}
			/>

			{/* Work Center error and success */}
				<Snackbar
					open={updateWorkCenterStatus === "error"}
					autoHideDuration={2000}
					onClose={() => {
						dispatch(resetUpdateWorkCenterData());
					}}
					anchorOrigin={{ vertical: "top", horizontal: "center" }}
				>
					<MuiAlert elevation={6} variant='filled' severity='error'>
						{updateWorkCenterErrorMessage ??
							"An Error Occurred. Please try again."}
					</MuiAlert>
				</Snackbar>
				<Snackbar
					open={updateWorkCenterStatus === "fulfilled"}
					autoHideDuration={1000}
					onClose={() => {
						dispatch(resetUpdateWorkCenterData());
						dispatch(setWorkCenterDialog(false));
						dispatch(
							getLocations(
								location[0].companyId
							)
						);
					}}
					anchorOrigin={{ vertical: "top", horizontal: "center" }}
				>
					<MuiAlert elevation={6} variant='filled' severity='success'>
						{"Workcenter updated"}
					</MuiAlert>
				</Snackbar>
				<Snackbar
					open={createNewWorkCenterStatus === "error"}
					autoHideDuration={2000}
					onClose={() => {
						dispatch(resetCreateNewWorkCenter());
					}}
					anchorOrigin={{ vertical: "top", horizontal: "center" }}
				>
					<MuiAlert elevation={6} variant='filled' severity='error'>
						{createNewWorkCenterErrorMessage ??
							"An Error Occurred. Please try again."}
					</MuiAlert>
				</Snackbar>
				<Snackbar
					open={createNewWorkCenterStatus === "fulfilled"}
					autoHideDuration={1000}
					onClose={() => {
						dispatch(resetCreateNewWorkCenter());
						dispatch(setWorkCenterDialog(false));
						setCreatingNewWorkCenter(false);
						dispatch(
							getLocations(
								location[0].companyId
							)
						);
					}}
					anchorOrigin={{ vertical: "top", horizontal: "center" }}
				>
					<MuiAlert elevation={6} variant='filled' severity='success'>
						{"New Workcenter added!"}
					</MuiAlert>
				</Snackbar>
		</>
	);
};

export default WorkCenters;
